export const prepareTariffsZasmotris = (bundles) => {
    return Object.values(bundles).filter(tariff => {
        const alias = tariff?.description?.alias;
        return alias.includes('zasmotris') || alias.includes('zasmotris-light');
    });
};

